import { __assign } from "tslib";
// DS: C115
import React, { useEffect } from 'react';
import { useDismissableNotification } from '../Notifications/Notification/useDismissableNotification';
import LiveNotificationCard from './_partials/LiveNotificationCard';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import liveNotificationsStyle from './LiveNotifications.scss';
var LiveNotification = function (_a) {
    var id = _a.id, queueName = _a.queueName, notificationHtml = _a.notificationHtml, linkTo = _a.linkTo, biData = _a.biData;
    var logBiEvent = useBiLogger();
    var _b = useDismissableNotification({
        id: id,
        queueName: queueName,
        duration: 10000,
    }), onClose = _b.onClose, onPause = _b.onPause, onUnpause = _b.onUnpause;
    useEffect(function () {
        logBiEvent(BiData(__assign({ evid: 656 }, biData)));
    }, [logBiEvent, biData]);
    return (React.createElement(LiveNotificationCard, { onClose: onClose, onMouseEnter: onPause, onMouseLeave: onUnpause, biData: biData }, linkTo ? (React.createElement(BiLink, { href: linkTo, className: liveNotificationsStyle['notification-link'], dangerouslySetInnerHTML: { __html: notificationHtml }, biData: BiData(__assign({ sectionid: BiContextProvidedValue, sectionname: BiContextProvidedValue, section_typeid: BiContextProvidedValue, sectiontype: BiContextProvidedValue, evid: 100 }, biData)) })) : (React.createElement(BiSpan, { dangerouslySetInnerHTML: { __html: notificationHtml }, biData: BiData(__assign({ sectionid: BiContextProvidedValue, sectionname: BiContextProvidedValue, section_typeid: BiContextProvidedValue, sectiontype: BiContextProvidedValue, evid: 100 }, biData)) }))));
};
LiveNotification.displayName = 'LiveNotification';
export default LiveNotification;
//# sourceMappingURL=LiveNotification.js.map